<template>
    <div>
        <div class="darkbg" @click="closeWin('')"></div>
        <div class="box ">
            <div class="block" style="background: #4f6f52;border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;">
                <div class="row" style="flex-direction: row; height:50px;">
                    <div class="left_c title childcenter" style="justify-content: left; width: 90%;">
                        <span style="font-size: 17px;color:white;padding-left:5px;"> Notification </span>
                    </div>
                    <div class="right_c title childcenter" style="width: 10%" @click="closeWin()">
                        <img src="/images/close.png" style="width: 19px; height: 19px; object-fit: cover" />
                    </div>
                </div>
            </div>
            <div style="margin-bottom:2rem;">

                <div class="block " v-if="hasContent(notice_lit)" v-for="(item, key) in notice_lit" :key="key"
                    style="margin:0px;">
                    <div v-for="(item2, key2) in item" :key="'con' + key2" class="r notice_lit">
                        <div class="block" style="margin-bottom:1rem!important;width:100%;">
                            <div class="r title" style="">
                                <div class="left_c"
                                    style='width:85%;overflow-wrap: break-word!important; white-space: normal!important;'>
                                    {{ getTitle(item2)}}
                                </div>
                                <div class="right_c" style='width:15%;color:#F92d2d;font-weight:normal;'>New</div>

                            </div>
                            <div class="r" v-if="item2['contentType']=='FILE_IMAGE'">
                            
                                <img :src="turnImage(item2['content'])" style="width: 3rem; height: 3rem; object-fit: cover" />
                            </div>
                            <div class="r" v-else>
                                {{ item2["content"] }}
                            </div>
                            <div class="r" style="">
                                <div class="left_c">

                                </div>
                                <div class="right_c hand" style='color:#1b80de' @click="toUrl(key, item2)">See More
                                    <img src="/images/index/right_top.png"
                                        style="width: 19px; height: 19px; object-fit: cover" />
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
                <div class="block " v-else style="margin:0px;">
                    <div class="r notice_lit">
                        <div class="block" style="margin-bottom:1rem!important;width:100%;">
                            <div class="r title" style="">
                                <div class="left_c"
                                    style='width:85%;overflow-wrap: break-word!important; white-space: normal!important;'>
                                    <!--  Message in My Inquiries -->
                                </div>
                                <div class="right_c" style='width:15%;color:#F92d2d;font-weight:normal;'></div>

                            </div>
                            <div class="r">
                                No messages
                            </div>
                            <div class="r" style="">
                                <div class="left_c">

                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
//import { useCartStore } from '@/stores/CartStore'
import { getCurrentInstance } from 'vue'
import Request from '@/services/Request'
import { formatAmount, notEmpty, formatDateLocal } from '@/utils/tool.js'
import { localDriver } from '@/utils/localDriver'

export default {
    props: {
        notice_lit: {
            type: [Object],
            default: () => ({})
        },
    },
    data() {
        return {

        }
    },

    mounted() {
    },

    async created() {
        const customer_id = await localDriver.getItem('customer_id')

    },

    methods: {
        getTitle(item)
        {
            let title=item.title;
            if(item.linkType == "ttg.order.service")title="Your TTG Expert left a message";
            else if(item.linkType == "ttg.order.operator")title="Operator message in Helpdesk";
            else if(item.linkType == "ttg.inquiry")title="Message in My Inquiries";
            else title=item.title;
            return title;
          //  item.linkType == "ttg.order.service" ? "Your TTG Expert left a message" :item.linkType == "ttg.order.service" ? "Operator message in Helpdesk" : item2["title"] 
        },
        turnImage(url)
        {            
            url=url.replace("../uploads/","/uploads/");
            if(url.indexOf('https://data.triptogo.com')<0&&url.indexOf('http://data.triptogo.com')<0)url="https://data.triptogo.com"+url;

            return url;
        },
        hasContent(obj) {
            if (!obj) return false
            try {
                return Object.values(obj).some((val) => {
                    if (!val) return false
                    if (Array.isArray(val) || typeof val === 'string') return val.length > 0
                    if (typeof val === 'object') return Object.keys(val).length > 0
                    return false
                })
            } catch (e) {
                return false
            }
        },
        toUrl(key, item) {
            console.log(key,item);
      
            let url = "";
            if (item.linkType == "ttg.order.service") {
                url = "/user/?active=2&activehelp=1&order_id=" + item.link + "&operator=Expert";
            }
            else if (item.linkType == "ttg.order.operator") {
                url = "/user/?active=2&activehelp=1&order_id=" + item.link + "&operator=Operator";
            }
           
            else if (item.linkType == "ttg.inquiry") {
                url = "/user/?active=4&activehelp=1&inquir_id=" + item.link + "";
            }
            else {
                url = "/user/?active=5";
            }
            if (url != "") {
                //  document.location = url;
                window.open(url);
            }

           /*  if (key == "order_inquire_export") {
                url = "/user/?active=2&activehelp=1&order_id=" + item.order_id + "&operator=Expert";
            }
            else if (key == "order_inquire_operator") {
                url = "/user/?active=2&activehelp=1&order_id=" + item.order_id + "&operator=Operator";
            }

            else if (key == "mystory") {
                url = "/user/?active=5";
            }
            else if (key == "product_inquire") {
                url = "/user/?active=4&activehelp=1&inquir_id=" + item.link + "";
            } */
          
        },
        closeWin() {

            this.$emit('closeNotice') // 当点击关闭按钮时，触发close事件
        },
        async cancel() {
            if (confirm('Are you sure to delete it?')) {
                await localDriver.removeItem('product_info')
                await localDriver.removeItem(this.odkey)
                this.product_info = this.default_product_info
            }
        },

    }
}
</script>



<style lang="scss" scoped>
.box {
    position: fixed;
    bottom: 35px;
    /* Changed bottom margin to 50px */
    right: 25px;
    transform: translate(0%, 0%);
    /* Removed vertical centering offset */
    background-color: white;
    width: 450px;
    height: auto;
    /* Changed height to 500px */
    max-height: 95%;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(18, 23, 70, 0.08);
    border-radius: 8px;
    opacity: 1;
    border-radius: 12px;
    z-index: 99999999;
    background: #fff;
    font-size: 1.7333rem;
    overflow-y: auto;

    .mod1 {
        background: #f9f8f6;
        border-radius: 15px;
        margin: 15px;
        padding: 0px;

        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            /*  border-bottom: 1px solid #d8d8d8; */
            padding-bottom: 16px;
            padding: 10px;
            padding-top: 10px;
            margin-top: 15px;

            img {
                width: 100%;

                border-radius: 6px;
            }

            .info {
                width: 100%;

                .name {
                    font-size: 17px;
                    text-align: left;

                    font-weight: bold;
                    color: #333333;
                    padding: 9px;
                    padding-left: 0px;

                    width: 100%;
                }

                .details {
                    margin-top: 21px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 10px 0px;

                    .d-con {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        margin: 8px;
                        background: #fff;
                        border-radius: 10px;
                        padding: 11px;

                        .d-con-t {
                            font-size: 1.4083rem;

                            font-weight: 400;
                            color: #a0a0a0;
                        }

                        .d-con-d {
                            margin-top: 8px;
                            font-size: 1.4083rem;

                            font-weight: 400;
                            color: #071525;
                        }
                    }
                }
            }

            .info2 {
                margin-left: auto;
                margin-right: 8px;

                .price {
                    font-size: 1.4083rem;

                    font-weight: 400;
                    color: #071525;
                    text-align: right;
                }

                .btns {
                    margin-top: 18px;
                    display: flex;
                    align-items: center;

                    .btn1 {
                        width: 50px;
                        height: 22px;

                        background: #a6a6a6;
                        border-radius: 14px;
                        font-size: 1.4083rem;

                        font-weight: bold;
                        color: #ffffff;
                        text-align: center;
                        line-height: 22px;
                        margin-right: 13px;
                    }

                    .btn2 {
                        width: 50px;
                        height: 22px;
                        background: #4ca771;
                        border-radius: 14px;
                        font-size: 1.4083rem;

                        font-weight: bold;
                        color: #ffffff;
                        text-align: center;
                        line-height: 22px;
                    }
                }
            }
        }
    }

    .head {
        display: flex;
        align-items: center;

        .title {
            font-size: 1.4083rem;

            font-weight: bold;
            color: #333333;
        }

        .cz {
            display: flex;
            align-items: center;
            margin-left: auto;

            .active {
                color: #4ca771 !important;
            }

            .btn {
                margin-left: 20px;
                font-size: 1.4083rem;

                font-weight: 400;
                color: #333333;
            }
        }
    }
}

:deep(.notice_lit) {

    background: #f6f6f6;
    border-radius: 10px;
    margin: 1.5rem !important;


}

.notice_lit .title {
    font-weight: bold;
}

.notice_lit .r {}

/* 移动端  */
@media screen and (max-width:750px) {
    .box {
        max-height: 90%;
        bottom: 3rem;
        /* Changed bottom margin to 50px */
        right: 1rem;
        transform: translate(0%, 0%);
        /* Removed vertical centering offset */

        width: 35rem;


    }
}
</style>
